<nav role="navigation" class="document_nav" aria-label="Page location indicator">
  <div role="tablist" aria-label="Page in Document">
    <button
      *ngFor="let page of visiblePages; let i = index"
      role="tab"
      class="nav_tab"
      [class.active_nav]="isPageActive(page)"
      [attr.aria-selected]="isPageActive(page) ? 'true' : 'false'"
      [attr.aria-label]="getTabAriaLabel(page)"
      [attr.aria-description]="getTabAriaDescription(page)"
      [attr.tabindex]="isPageFocused(i) ? 0 : -1"
      (click)="activateTab(page)"
      (keydown)="onTabKeydown($event, i)">
      <span aria-hidden="true" [ngClass]="{ has_highlights: highlightedPagesMap[getPageNumber(page)] }">
        {{ page.ellipsis ? '...' : page }}
      </span>
    </button>
  </div>
</nav>